import { INode } from "@/app/api/cache/route";
import { BASE_URL } from "@/config";

export const insertNodes = async (nodes: any[]) => {
  try {
    const response = await fetch(`/api/cache`, {
      method: "POST",
      body: JSON.stringify({ nodes }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const getNodes = async (
  page?: number,
  limit?: number,
  search?: string
) => {
  try {
    const response = await fetch(
      `/api/cache?page=${page || ""}&limit=${limit || ""}&search=${
        search || ""
      }`
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
  }
};

export const addNode = async (node: Partial<INode>) => {
  try {
    const response = await fetch(`/api/cache`, {
      method: "PUT",
      body: JSON.stringify({ node }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// export const updateProvider = async (nodeId: string, providerId: string) => {
//   try {
//     const response = await fetch(`/api/cache`, {
//       method: "PATCH",
//       body: JSON.stringify({ nodeId, providerId }),
//     });
//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };

export interface IUpdateCacheDetails {
  nodeId: string;
  providerId?: string;
  gpuName?: string;
  gpuNum?: number;
  cpuName?: string;
  cpuId?: string;
  cpuNum?: number;
  totalMemory?: number;
  totalStorage?: number;
  removeGpu?: boolean;
}

export const updateNodeCache = async ({
  nodeId,
  providerId,
  gpuName,
  gpuNum,
  cpuName,
  cpuId,
  cpuNum,
  totalMemory,
  totalStorage,
  removeGpu = false,
}: IUpdateCacheDetails) => {
  try {
    const response = await fetch(`/api/cache`, {
      method: "PATCH",
      body: JSON.stringify({
        nodeId,
        providerId,
        gpuName,
        gpuNum,
        cpuName,
        cpuId,
        cpuNum,
        totalMemory,
        totalStorage,
        removeGpu,
      }),
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

type BoosterDataResponse =
  | {
      hasStellarBooster: boolean;
      pointsBeforeStellarBooster: number;
      status: "success";
    }
  | {
      status: "failed";
      message: string;
    };

export const getBoosterDataForNode = async (address: string) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/cache/booster-data?address=${address}`,
      {
        method: "GET",
      }
    );
    const data = await response.json();
    if (data.status === "success")
      return {
        hasStellarBooster: data.hasStellarBooster,
        pointsBeforeStellarBooster: data.pointsBeforeStellarBooster,
      };
    else
      return {
        hasStellarBooster: false,
        pointsBeforeStellarBooster: 0,
        failed: true,
      };
  } catch (error) {
    console.error(error);
    return {
      hasStellarBooster: false,
      pointsBeforeStellarBooster: 0,
      failed: true,
    };
  }
};
